var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/engine-user-agent.js